import React from 'react';
import { useSiteMetadata } from '../../hooks';

export default function SEO({
	title,
	subtitle,
	image,
	description,
	pathname,
	type = 'website',
	children,
}) {
	// https://www.gatsbyjs.com/docs/how-to/adding-common-features/adding-seo-component/
	const {
		title: defaultTitle,
		description: defaultDescription,
		image: defaultImage,
		siteUrl,
		twitterUsername,
	} = useSiteMetadata();

	// Determine the title based on what props are passed
	let computedTitle = defaultTitle;
	if (title && subtitle) {
		computedTitle = `${title} | ${subtitle}`;
	} else if (title) {
		computedTitle = `${title} | ${defaultTitle}`;
	}

	const seo = {
		title: computedTitle,
		description: description
			? description + ' | ' + defaultDescription
			: defaultDescription,
		image: `${siteUrl}${image || defaultImage}`,
		url: `${siteUrl}${pathname || ``}`,
		type,
		siteName: defaultTitle, // Uses your global site title as the site name
	};

	return (
		<>
			<html lang="en" />
			{/* Standard Meta Tags */}
			<title>{seo.title}</title>
			<meta name="description" content={seo.description} />
			<meta name="image" content={seo.image} />
			{/* Open Graph Tags (Facebook, LinkedIn, Discord, Slack) */}
			<meta property="og:title" content={seo.title} />
			<meta property="og:description" content={seo.description} />
			<meta property="og:image" content={seo.image} />
			<meta property="og:url" content={seo.url} />
			<meta property="og:type" content={seo.type} />
			<meta property="og:site_name" content={seo.siteName} />{' '}
			{/* Twitter Card Tags */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={seo.title} />
			<meta name="twitter:description" content={seo.description} />
			<meta name="twitter:image" content={seo.image} />
			{twitterUsername && (
				<meta name="twitter:creator" content={twitterUsername} />
			)}
			{children}
		</>
	);
}
